import * as React from "react"

const _MouthSmile = ({ isEditor }: { isEditor: boolean }) => {
  return (
    <svg
      style={{
        width: !isEditor ? "50%" : "80%",
        height: !isEditor ? "17%" : "80%",
        position: "absolute",
        top: !isEditor ? "23%" : "42%",
        right: !isEditor ? "23%" : "6%"
      }}
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0007 24.1649C14.941 30.6115 22.4277 37.7537 33.9767 36.125C45.5257 34.4963 50.6642 26.5297 49.1492 20.0779"
        stroke="black"
        strokeWidth="4"
      />
    </svg>
  )
}

export const MouthSmile = React.memo(_MouthSmile)
